define('modules/templates/collections/templates',['require','exports','module','backbone','env','i18n','../models/template'],function (require, exports, module) {
  "use strict";
  var Backbone = require('backbone'),
      config = require('env'),
      i18n = require('i18n'),
      Template = require('../models/template');

  module.exports = Backbone.Collection.extend({
    model: Template,
    initialize: function (models, options) {
      this.platform = options.platform;
    },

    parse: function (response) {
      //leave out templates without content or whatever
      return _.filter(response, function (template) {
        return template.content !== null && template.confirmation !== null;
      });
    },

    getCurrentLang: function () {
      return (i18n.lng()).substr(0, 2);
    },

    url: function () {
      return config.apiHost + '/templates?platform=' + this.platform + '&language=' + this.getCurrentLang();
    }
  });
});

